<div class="app-content dashboard flex-fill flex flex-start-stretch">
  <div class="flex-column flex-gap-10 flex-fill">
     <div *ngIf="showDashboard" class="dashboard-content flex-row flex-gap-20 flex-fill">
      <div class="flex-column flex-auto at-a-glance-section" *ngIf="showAtAGlance">
        <ssg-at-a-glance></ssg-at-a-glance>
      </div>
      <div class="flex-column flex-auto flex-gap-20 widgets-column">
        <div *ngIf="showAlerts">
          <ssg-alerts class="alerts_and_notifications_widget"></ssg-alerts>
        </div>
        <div *ngIf="showQuickActions">
          <ssg-quick-actions class="quick_actions_widget"></ssg-quick-actions>
        </div>
      </div>
      <!-- To match the UI Mockup we have commented the div related to feature implementation.
           When new section comes in future, changes for the existing div need to be accomodated to fit in the page. -->
      <!-- <div fxLayout="column" fxFlex="33%" fxLayoutGap="20px">
        <div fxFlex="50%" *ngIf="nonAtAGlanceEnabled">
          Will be feature flagged to enable section when implemented
          <ssg-resources></ssg-resources>
        </div>
        <div fxFlex="50%" *ngIf="nonAtAGlanceEnabled">
          Will be feature flagged to enable section when implemented
          <ssg-pay-details></ssg-pay-details>
        </div>
      </div>
    </div> -->
  </div>
</div>
